import { onResponse } from 'hub-http/middlewares/core';
import { actions } from 'in-meeting-experience-ui-components/contexts/error/context';
import { history } from 'in-meeting-experience-ui-components/utils/general';
import { AUTH_ERROR_SUB_CATEGORY } from '../constants/errors';
import { routes } from '../constants/routes';
const thirdPartyAuthErrorMiddleware = options => onResponse(response => {
  if (response.isErrorHandled || response.options.ignoreErrors) return response;
  if (!response.responseJSON) return response;
  if (typeof response.responseJSON.subCategory === 'string' && response.responseJSON.subCategory.includes(AUTH_ERROR_SUB_CATEGORY)) {
    response.isErrorHandled = true;
    actions.setError({
      showError: true,
      message: response.responseJSON.message,
      ctaFunction: () => {
        history.push(routes.reconnect);
      }
    });
    return response;
  }
  return response;
})(options);
export default thirdPartyAuthErrorMiddleware;